export default {
  'wallet': 'Wallet',
  'Select Crypto': 'Select Crypto',
  'Select Network': 'Select Network',
  'Crypto': 'Crypto',

  'deposit.faq': 'FAQ',
  'deposit.faq_1': 'What If I Deposit The Wrong Token?',
  'deposit.faq_2': 'Deposit Hasn’t Been Credited To My Account?',
  'deposit.faq_3': "What should I do if I don't get the currency?",

  'Recent Deposits': 'Recent Deposits',
  'deposit.history': 'History',

  'deposit_tip':
    'Please note that only supported networks on Biconomy platform are shown.if you deposit via another network your assets may be lost',
  'deposit_address_tap': 'Tap to generate address'
};
